var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKtceStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1760,
    height: 720,
    viewBox: "0 0 1760 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Katoghan"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1760,
    height: 720
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Katoghan",
    clipPath: "url(#clip-Katoghan)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1760,
    height: 720
  }), /*#__PURE__*/React.createElement("g", {
    id: "YardLayout",
    transform: "translate(-22 -18.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Seperator",
    transform: "translate(-212.103 -100.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR01",
    d: "M118.991-.5h-21l-81,65h-17",
    transform: "translate(778.112 320.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR03",
    d: "M-.025,1.275h13l80,65h18",
    transform: "translate(789.128 468.726)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR10",
    x2: 123,
    transform: "translate(898.5 320.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR09",
    x2: 107,
    transform: "translate(1364.103 320.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR08",
    d: "M.667,7.346,8.828,0H113",
    transform: "translate(874.103 540.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR07",
    d: "M0,0H111.406l9.815,5.837",
    transform: "translate(1343.103 540.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR11",
    d: "M-.163,2.138H9.781l40,50,12.246.035",
    transform: "translate(990.321 542.863)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TR12",
    d: "M4.133,5.074,11.026.5H123.765",
    transform: "translate(1029.603 600.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-.449,63.584H13.742L143.825-1.839h12.8",
    transform: "translate(618.5 397.134)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-1.458,66.5h11l60.583-65H82.542",
    transform: "translate(1443.561 468.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-2.669,3.138h13L59.059,67.93H70.71",
    transform: "translate(1546.771 391.863)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-10.089.383H3.218l58.646,60h11",
    transform: "translate(1468.238 324.618)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shunt",
    transform: "translate(-203 -89.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SH26",
    transform: "translate(1234.033 277.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SH26Poles",
    d: "M0,12V-.11H4.613",
    transform: "translate(1.498 16.197)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH26Aspect3",
    transform: "translate(5.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH26Aspect2",
    transform: "translate(21.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH26Aspect1",
    transform: "translate(13.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH26Label",
    transform: "translate(-1.389 9.087)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-26\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH31",
    transform: "translate(994.15 347.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SH31Poles",
    d: "M0,12V-.11H4.613",
    transform: "translate(1.498 16.197)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH31Aspect3",
    transform: "translate(5.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH31Aspect2",
    transform: "translate(21.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH31Aspect1",
    transform: "translate(13.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH31Label",
    transform: "translate(2.611 9.087)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-31\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH24",
    transform: "translate(1317.033 348.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SH24Poles",
    d: "M0,12V-.11H4.613",
    transform: "translate(1.498 16.197)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH24Aspect3",
    transform: "translate(5.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH24Aspect2",
    transform: "translate(21.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH24Aspect1",
    transform: "translate(13.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH24Label",
    transform: "translate(3.967 5.119)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-24\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH33",
    transform: "translate(978.68 422.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SH33Poles",
    d: "M0,12V-.11H4.613",
    transform: "translate(1.498 16.197)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH33Aspect3",
    transform: "translate(5.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH33Aspect2",
    transform: "translate(21.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH33Aspect1",
    transform: "translate(13.611 12.087)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH33Label",
    transform: "translate(4.202 7.119)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-33\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH37",
    transform: "translate(969.042 455.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SH37Poles",
    d: "M4.613-.11V12H0",
    transform: "translate(25.112 0.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH37Aspect3",
    transform: "translate(17.612 8.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH37Aspect2",
    transform: "translate(1.612 8.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH37Aspect1",
    transform: "translate(9.612 8.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH37Label",
    transform: "translate(3.575 27.112)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-37\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SH35",
    transform: "translate(940.929 530.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SH35Poles",
    d: "M4.613-.11V12H0",
    transform: "translate(25.112 0.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SH35Aspect3",
    transform: "translate(17.612 8.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH35Aspect2",
    transform: "translate(1.612 8.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH35Aspect1",
    transform: "translate(9.612 8.11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4,
    rx: 3.5,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH35Label",
    transform: "translate(6.108 31.112)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-35\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "Signal",
    transform: "translate(-116 -92.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS6",
    transform: "translate(1344.493 308.883) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS6Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS6Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES",
    transform: "translate(29.342 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1",
    y2: 13.952,
    transform: "translate(7.972 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS6Label",
    transform: "translate(22.357 26) rotate(-179.7)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-6\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGS19",
    transform: "translate(429.828 470.257) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS19Aspect2",
    transform: "translate(18.227 -5.226)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS19Aspect1",
    transform: "translate(33.226 -5.147)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-2",
    "data-name": "POLES",
    transform: "translate(48.347 -11.559)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-2",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-2",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS19Label",
    transform: "translate(23.187 18.865) rotate(0.3)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-19\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGC18",
    transform: "translate(404.609 383.948) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGC18Aspect",
    transform: "translate(14.491 12.504)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 5,
    ry: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 4.25,
    ry: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-3",
    "data-name": "POLES",
    transform: "translate(29.296 36.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "POLES1-3",
    "data-name": "POLES1",
    d: "M13,0l-.063,13L0,12.927",
    transform: "translate(-4.988 -32.003)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 11,
    y1: 0.058,
    transform: "translate(-25.278 -19.167)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGC1Aspect",
    transform: "translate(40.189 25.233) rotate(-179.7)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tC-18\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGS18",
    transform: "translate(392.071 363.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS1Aspect2",
    transform: "translate(8.023 -4.672)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS1Aspect1",
    transform: "translate(23.023 -4.672)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "S-18",
    transform: "translate(12 -7.787) rotate(0.3)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-18\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGS11",
    transform: "translate(1016 378.883) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS11Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS11Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-4",
    "data-name": "POLES",
    transform: "translate(29.342 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-4",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-3",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS11LABEL",
    transform: "translate(25.984 25.095) rotate(-179.7)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-11\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGS4",
    transform: "translate(1541.493 378.883) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS4Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS4Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-5",
    "data-name": "POLES",
    transform: "translate(29.342 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-5",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-4",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS4LABEL",
    transform: "translate(22.984 25.079) rotate(-179.7)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-4\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGS17",
    transform: "translate(914.818 471.363) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS17Aspect2",
    transform: "translate(18.227 -5.226)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS17Aspect1",
    transform: "translate(33.305 -5.147)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-6",
    "data-name": "POLES",
    transform: "translate(21.406 -12.318)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-6",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(34.134 0.133)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-5",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(26.163 14.016)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS17Label",
    transform: "translate(26.073 20.774) rotate(0.3)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-17\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGS15",
    transform: "translate(781.32 546.632) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS15Aspect2",
    transform: "translate(18.227 -5.226)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS15Aspect1",
    transform: "translate(33.305 -5.147)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-7",
    "data-name": "POLES",
    transform: "translate(21.406 -12.318)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-7",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(34.134 0.133)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-6",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(26.163 14.016)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGS15Label",
    transform: "translate(26.053 24.774) rotate(0.3)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tS-15\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TrackCircuit",
    transform: "translate(-207.5 -91.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TCDMT1",
    className: "tooltip",
    title: "",
    transform: "translate(-19 1.501)",
    "edge-id": "KTCE_TC_DMT1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDMT1Line",
    x2: 80,
    transform: "translate(1015.5 379)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_DMT1Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDMT1Label",
    transform: "translate(1040.5 391)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_DMT1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tDMT1\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCC18T",
    className: "tooltip",
    title: "",
    transform: "translate(103 2.001)",
    "edge-id": "KTCE_TC_C18T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC18TLine",
    x2: 128,
    transform: "translate(272.5 378.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_C18TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC18TLabel",
    transform: "translate(323.5 375.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_C18TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tC18T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC18T",
    className: "tooltip",
    title: "",
    transform: "translate(20 1.001)",
    "edge-id": "KTCE_TC_18T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC18TLine",
    x2: 130,
    transform: "translate(486.5 379.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_18TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC18TLabel",
    transform: "translate(542 376.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_18TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t18T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT2",
    className: "tooltip",
    title: "",
    transform: "translate(-35)",
    "edge-id": "KTCE_TC_DMT2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDMT2Line",
    x2: 146,
    transform: "translate(1114.5 380.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_DMT2Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDMT2Label",
    transform: "translate(1172.5 377.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_DMT2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tDMT2\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT3",
    className: "tooltip",
    title: "",
    transform: "translate(-62)",
    "edge-id": "KTCE_TC_DMT3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDMT3Line",
    x2: 124,
    transform: "translate(1290.5 380.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_DMT3Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDMT3Label",
    transform: "translate(1337.5 377.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_DMT3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tDMT3\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC47T",
    className: "tooltip",
    title: "",
    transform: "translate(-92 3)",
    "edge-id": "KTCE_TC_47T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC47TLine",
    x2: 181,
    transform: "translate(1447.5 377.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_47TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC47TLabel",
    transform: "translate(1528.5 374.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_47TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t47T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC55T",
    className: "tooltip",
    title: "",
    transform: "translate(0 1.501)",
    "edge-id": "KTCE_TC_55T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC55TLine",
    x2: 220,
    transform: "translate(773.5 379)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_55TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC55TLabel",
    transform: "translate(874 376)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_55TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t55T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC19T",
    className: "tooltip",
    title: "",
    transform: "translate(49)",
    "edge-id": "KTCE_TC_19T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC19TLine",
    x2: 100,
    transform: "translate(368.5 455.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_19TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC19TLabel",
    transform: "translate(409 452.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_19TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t19T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC60BT",
    className: "tooltip",
    title: "",
    transform: "translate(32 -1.75)",
    "edge-id": "KTCE_TC_60BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC60BTLine",
    x2: 168,
    transform: "translate(581.5 457.251)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_60BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC60BTLabel",
    transform: "translate(652.5 454.251)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_60BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t60BT\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT3",
    className: "tooltip",
    title: "",
    transform: "translate(-33)",
    "edge-id": "KTCE_TC_UMT3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUMT3Line",
    x2: 154,
    transform: "translate(1015.5 455.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_UMT3Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUMT3Label",
    transform: "translate(1077.5 452.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_UMT3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tUMT3\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT2",
    className: "tooltip",
    title: "",
    transform: "translate(-60)",
    "edge-id": "KTCE_TC_UMT2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUMT2Line",
    x2: 90,
    transform: "translate(1199.5 455.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_UMT2Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUMT2Label",
    transform: "translate(1229.5 452.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_UMT2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tUMT2\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT1",
    className: "tooltip",
    title: "",
    transform: "translate(-80)",
    "edge-id": "KTCE_TC_UMT1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUMT1Line",
    x2: 105,
    transform: "translate(1312.5 455.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_UMT1Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUMT1Label",
    transform: "translate(1350.5 452.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_UMT1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tUMT1\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC43T",
    className: "tooltip",
    title: "",
    transform: "translate(-107 -0.5)",
    "edge-id": "KTCE_TC_43T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC43TLine",
    x2: 181,
    transform: "translate(1447.5 456.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_43TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC43TLabel",
    transform: "translate(1528.5 453.001)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_43TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t43T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC51T",
    className: "tooltip",
    title: "",
    "edge-id": "KTCE_TC_51T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC51TLine",
    x2: 195,
    transform: "translate(784.5 455.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_51TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC51TLabel",
    transform: "translate(872.5 452.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_51TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t51T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCDULT1",
    className: "tooltip",
    title: "",
    transform: "translate(2 -2)",
    "edge-id": "KTCE_TC_DULT1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDULT1Line",
    x2: 75,
    transform: "translate(1017.5 312.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_DULT1Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDULT1Label",
    transform: "translate(1036.5 309.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_DULT1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\n\t\t\t\t\t\t\tDULT1\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCDULT2",
    className: "tooltip",
    title: "",
    transform: "translate(3)",
    "edge-id": "KTCE_TC_DULT2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDULT2Line",
    x2: 136,
    transform: "translate(1094.5 310.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_DULT2Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDULT2Label",
    transform: "translate(1145.5 307.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_DULT2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tDULT2\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCDULT3",
    className: "tooltip",
    title: "",
    transform: "translate(3 -2)",
    "edge-id": "KTCE_TC_DULT3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDULT3Line",
    x2: 119,
    transform: "translate(1233.5 312.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_DULT3Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDULT3Label",
    transform: "translate(1276 309.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_DULT3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tDULT3\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCULT1",
    className: "tooltip",
    title: "",
    transform: "translate(0 25)",
    "edge-id": "KTCE_TC_ULT1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCULT1Label",
    transform: "translate(1271.5 502.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_ULT1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tULT1\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TCULT1Line",
    x2: 102,
    transform: "translate(1233.5 505.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_ULT1Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TCULT3",
    className: "tooltip",
    title: "",
    transform: "translate(0 21)",
    "edge-id": "KTCE_TC_ULT3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCULT3Line",
    x2: 121,
    transform: "translate(985.5 509.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_ULT3Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCULT3Label",
    transform: "translate(1033 506.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_ULT3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tULT3\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCULT2",
    className: "tooltip",
    title: "",
    transform: "translate(0 25)",
    "edge-id": "KTCE_TC_ULT2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCULT2Line",
    x2: 121,
    transform: "translate(1109.5 505.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_ULT2Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCULT2Label",
    transform: "translate(1157 502.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_ULT2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tULT2\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC4T",
    className: "tooltip",
    title: "",
    transform: "translate(40 3.001)",
    "edge-id": "KTCE_TC_4T"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TC4TLabel",
    transform: "translate(1622 374.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_4TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\n\t\t\t\t\t\t\t4T\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC4TLine",
    x2: 80,
    transform: "translate(1592.5 377.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_4TLine"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TC3T",
    className: "tooltip",
    title: "",
    transform: "translate(24 0.5)",
    "edge-id": "KTCE_TC_3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3TLine",
    x2: 90,
    transform: "translate(1592.5 455.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_3TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3TLabel",
    transform: "translate(1631.5 452.001)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t3T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCC3T",
    className: "tooltip",
    title: "",
    transform: "translate(50)",
    "edge-id": "KTCE_TC_C3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC3TLine",
    x2: 100,
    transform: "translate(1659.5 455.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_C3TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC3TLabel",
    transform: "translate(1700 452.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_C3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tC3T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC17T",
    className: "tooltip",
    title: "",
    transform: "translate(152)",
    "edge-id": "KTCE_TC_17T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC17TLine",
    x2: 90,
    transform: "translate(368.5 455.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_17TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC17TLabel",
    transform: "translate(404 452.501)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_17TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t17T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC41AT",
    className: "tooltip",
    title: "",
    transform: "translate(-53 -74.5)",
    "edge-id": "KTCE_TC_41AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC41ATLine",
    x2: 90,
    transform: "translate(1592.5 455.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_41ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC41ATLabel",
    transform: "translate(1624.5 467.001)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_41ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t41AT\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC2T",
    className: "tooltip",
    title: "",
    transform: "translate(123 -74.5)",
    "edge-id": "KTCE_TC_2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC2TLine",
    x2: 90,
    transform: "translate(1592.5 455.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC2TLabel",
    transform: "translate(1631.5 452.001)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t2T\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC41BT",
    className: "tooltip",
    title: "",
    transform: "translate(-68 0.5)",
    "edge-id": "KTCE_TC_41BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC41BTLine",
    x2: 89,
    transform: "translate(1592.5 455.001)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_41BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC41BTLabel",
    transform: "translate(1624 452.001)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_41BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t41BT\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC60AT",
    className: "tooltip",
    title: "",
    transform: "translate(153 1.001)",
    "edge-id": "KTCE_TC_60AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC60ATLine",
    x2: 131,
    transform: "translate(486.5 379.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "KTCE_TC_60ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC60ATLabel",
    transform: "translate(542.5 376.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_TC_60ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t60AT\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "PointMachine",
    transform: "translate(-213 -96.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM51A",
    className: "tooltip",
    title: "",
    transform: "translate(10.5 35.749)",
    "edge-id": "KTCE_PM_51A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM51AIcon",
    transform: "translate(871 477.375)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_51AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM51AHr",
    transform: "translate(888.296 479.495) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_51AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM51AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_51AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM51AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_51AHr2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM51ALabel",
    transform: "translate(868.5 475.375)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_51ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t51A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM47A",
    className: "tooltip",
    title: "",
    transform: "translate(29 -13)",
    "edge-id": "KTCE_PM_47A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM47AIcon",
    transform: "translate(1428.5 336.5)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_47AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM47ALabel",
    transform: "translate(1426 363.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_47ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t47A\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PM47AHr",
    transform: "translate(1418.964 339.746) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_47AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM47AAHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_47AAHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM47AAHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_47AAHr2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PM55A",
    className: "tooltip",
    title: "",
    transform: "translate(1 -20)",
    "edge-id": "KTCE_PM_55A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM55AIcon",
    transform: "translate(879.5 317.375)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_55AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM55AHr",
    transform: "translate(898.796 316.368) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_55AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM55AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_55AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM55AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_55AHr2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM55ALabel",
    transform: "translate(877 314.375)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_55ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t55A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM55B",
    className: "tooltip",
    title: "",
    transform: "translate(-35 -9)",
    "edge-id": "KTCE_PM_55B"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_PM55BLabel",
    "data-name": "  PM55BLabel",
    transform: "translate(812.5 367.754)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "_KTCE_PM_55BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t55B\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PM55BHr",
    transform: "translate(804.801 372.848)",
    "edge-id-selector": "KTCE_PM_55BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM55BHr1",
    d: "M5,8.7C2.312,6.961.9,5.381.323,4.059-1.226.515,3.2-1.179,5,.913c1.8-2.092,6.226-.4,4.677,3.146C9.1,5.381,7.688,6.961,5,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_55BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM55BHr2",
    d: "M0,1.239H0l2.928.014L3.334.012,5.162,2.675l.669-1.552,3.6.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_55BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM55BIcon",
    transform: "translate(815 370.754)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_55BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PM43A",
    className: "tooltip",
    title: "",
    transform: "translate(19.57 56)",
    "edge-id": "KTCE_PM_43A"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PM43ALabel",
    transform: "translate(1419.508 509)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_43ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t43A\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PM43AHr",
    transform: "translate(1410.176 487.175) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_43AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM43AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    fill: "none",
    "edge-id-selector": "KTCE_PM_43AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM43AHr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_43AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM43AIcon",
    transform: "translate(1421.008 483)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_43AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PM51B",
    className: "tooltip",
    title: "",
    transform: "translate(-49 5)",
    "edge-id": "KTCE_PM_51B"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PM51BLabel",
    transform: "translate(836 491.124)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_51BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t51B\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PM51BHr",
    transform: "translate(828.296 466.244) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_51BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM51BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_51BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM51BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_51BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM51BIcon",
    transform: "translate(837.832 464.124)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_51BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PM60A",
    className: "tooltip",
    title: "",
    transform: "translate(72 35.127)",
    "edge-id": "KTCE_PM_60A"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PM60ALabel",
    transform: "translate(687 386)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_60ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t60A\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PM60AIcon",
    transform: "translate(689.5 359)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_60AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM60AAHr",
    transform: "translate(704.296 361.119) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_60AAHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM60AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "KTCE_PM_60AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM60AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_60AHr2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PM60B",
    className: "tooltip",
    title: "",
    transform: "translate(-16 -19.373)",
    "edge-id": "KTCE_PM_60B"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PM60BLabel",
    transform: "translate(632 454.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_60BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t60B\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PM60BHr",
    transform: "translate(624.964 463.993) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_60BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM60BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_60BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM60BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_60BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM60BIcon",
    transform: "translate(634.5 457.5)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_60BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PM43B",
    className: "tooltip",
    title: "",
    transform: "translate(24.168 -6)",
    "edge-id": "KTCE_PM_43B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM43BIcon",
    transform: "translate(1491.164 475)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_43BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM43BHr",
    transform: "translate(1507.628 483.119) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_43BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM43BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "KTCE_PM_43BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM43BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_43BHr2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TC43BLabel",
    transform: "translate(1488.664 502)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t43B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM41A",
    className: "tooltip",
    title: "",
    transform: "translate(36.584 19.339)",
    "edge-id": "KTCE_PM_41A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM41AIcon",
    transform: "translate(1507.416 374.537)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_41AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM41AHr",
    transform: "translate(1496.217 379.245)",
    "edge-id-selector": "KTCE_PM_41AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM41AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_41AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM41AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_41AHr2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM41ALabel",
    transform: "translate(1505 401)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_41ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t41A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM41B",
    className: "tooltip",
    title: "",
    transform: "translate(29 0.339)",
    "edge-id": "KTCE_PM_41B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM41BIcon",
    transform: "translate(1576 437)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_41BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM41BHr",
    transform: "translate(1591.796 437.746) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_41BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM41BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_41BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM41BAHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_41BAHr2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM41BLabel",
    transform: "translate(1574 434)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_41BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t41B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM47B",
    className: "tooltip",
    title: "",
    transform: "translate(27.87 4.629)",
    "edge-id": "KTCE_PM_47B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM47BIcon",
    transform: "translate(1501.334 358)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "KTCE_PM_47BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM47BHr",
    transform: "translate(1522.176 358.972) rotate(-0.3)",
    "edge-id-selector": "KTCE_PM_47BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM47BHr1",
    d: "M4.643,8.7c2.5-1.737,3.806-3.317,4.343-4.639C10.425.515,6.316-1.179,4.643.913,2.971-1.179-1.138.515.3,4.059.837,5.381,2.147,6.961,4.643,8.7Z",
    transform: "translate(-3.859 1.057)",
    fill: "none",
    "edge-id-selector": "KTCE_PM_47BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM47BHr2",
    d: "M0,1.26H0l2.711.014L3.087.012,4.779,2.721,5.4,1.143l3.336.118",
    transform: "translate(-3.277 4.018)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "KTCE_PM_47BHr2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM47BLabel",
    transform: "translate(1498.834 355)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "KTCE_PM_47BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t47B\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "StationInfo",
    transform: "translate(9.5 -19)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "StationInfo-2",
    "data-name": "StationInfo",
    transform: "translate(830.5 138.215)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\tKATOGHAN\n\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H180",
    transform: "translate(820.5 106.215)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "StationInfoenglish",
    transform: "translate(866.5 98.215)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "NirmalaUI, Nirmala UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\u0915\u091F\u094B\u0918\u0928\n\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "Legend",
    transform: "translate(116.638 -53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegend",
    transform: "translate(1013.194 -354.998)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PMLegendLabel",
    transform: "translate(227 974)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tPOINT MACHINE\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormal",
    transform: "translate(227 979.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormalIndicator",
    transform: "translate(0 0.232)",
    fill: "none",
    stroke: "#21e074",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendNormalLabel",
    transform: "translate(32 16.232)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tNORMAL\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverse",
    transform: "translate(227 1003.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverseIndicator",
    transform: "translate(0 0.416)",
    fill: "none",
    stroke: "#0088d1",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendReverseLabel",
    transform: "translate(30 15.416)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tREVERSE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendHr",
    transform: "translate(227.929 1024.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr1",
    d: "M10.433,19.646C4.823,15.724,1.881,12.155.675,9.168c-3.232-8,6-11.832,9.758-7.107,3.758-4.725,12.991-.9,9.758,7.107C18.985,12.155,16.043,15.724,10.433,19.646Z",
    transform: "translate(0 3.457)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr2",
    d: "M-.094.01H5.175L7.357-3.307l2.832,6.271L12.232.01,19.327,0",
    transform: "translate(0.807 12.769)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendFailureLabel",
    transform: "translate(28.702 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFAILURE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendCanvas",
    transform: "translate(216 955)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 124,
    height: 107,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegend",
    transform: "translate(479.194 -412.998)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCLegendLabel",
    transform: "translate(898 1032)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tTRACK CIRCUIT\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "TCFreeLegendGroup",
    transform: "translate(888.5 1040.52)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFreeLegendIndicator",
    x2: 70,
    transform: "translate(-2 10.474)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFreeLegendLabel",
    transform: "translate(75.5 15.974)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFREE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOccupiedLegendGroup",
    transform: "translate(897.5 1061.093)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOccupiedLegendIndicator",
    x2: 70,
    transform: "translate(-11 12.846)",
    fill: "none",
    stroke: "#e77e00",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOccupiedLegendLabel",
    transform: "translate(65.921 18.346)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tOCCUPIED\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCFailureLLegendGroup",
    transform: "translate(897.5 1083.744)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFailureLegendIndicator",
    x2: 70,
    transform: "translate(-11 11.296)",
    fill: "none",
    stroke: "red",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFailureLLegendLabel",
    transform: "translate(68 16.796)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFAILURE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegendCanvas",
    transform: "translate(876 1013)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 157,
    height: 107,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "RRPM"
  }, /*#__PURE__*/React.createElement("line", {
    id: "LineRR",
    x2: 200,
    transform: "translate(405 578.501)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "RR55A",
    className: "tooltip",
    title: "",
    transform: "translate(-318 -319.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "RR55AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(737 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RR55ALable",
    transform: "translate(716 906)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n\t\t\t\t\t\t\t55A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "RR41A",
    className: "tooltip",
    title: "",
    transform: "translate(-318 -319.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "RR41AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(817 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RR41ALable",
    transform: "translate(797 906)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n\t\t\t\t\t\t\t41A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "RR43A",
    className: "tooltip",
    title: "",
    transform: "translate(-318 -319.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "RR43AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(897 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RR43ALable",
    transform: "translate(876 906)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n\t\t\t\t\t\t\t43A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "RR47A",
    className: "tooltip",
    title: "",
    transform: "translate(-318 -319.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "RR47AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(937 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RR47ALable",
    transform: "translate(918 906)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "\n\t\t\t\t\t\t\t47A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "RR51A",
    className: "tooltip",
    title: "",
    transform: "translate(-318 -319.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "RR51AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(857 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RR51ALable",
    transform: "translate(836 906)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n\t\t\t\t\t\t\t51A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "RR60A",
    className: "tooltip",
    title: "",
    transform: "translate(-318 -319.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "RR60AIcon",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(777 886) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RR60ALable",
    transform: "translate(757 906)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n\t\t\t\t\t\t\t60A\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(359 540.501)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 306,
    height: 98,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "RELAY_ROOM_PM_HEALTH",
    "data-name": "RELAY ROOM PM HEALTH",
    transform: "translate(427 610)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\tRELAY ROOM PM HEALTH\n\t\t\t")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKtceStation);
export default __webpack_public_path__ + "static/media/KTCE_Station.271221b22796f8484cf54df758f5cebb.svg";
export { ForwardRef as ReactComponent };